<template>
  <!--
    (2-col) 544
    sm:max-w-136
    (3-col) 816
    lg:max-w-204
    (4-col) 1088
    xl:max-w-272
  -->
  <div :class="wrapClasses">
    <ol
      v-if="usedArr(list)"
      :class="olClasses"
      class="card-list"
    >
      <li
        v-for="item in list"
        :key="item.slug"
        :class="liClasses"
        class="card-list__item"
      >
        <Card :post-obj="item" />
      </li>
    </ol>
  </div>
</template>

<script>
import Card from '@/components/buttons/Card.vue'

export default {
  name: 'CardList',

  components: {
    Card
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },
    leftAlign: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    wrapClasses() {
      return [
        'sm:max-w-136 lg:max-w-204 xl:max-w-272',
        'mx-auto mb-7 last:mb-0',
      ]
    },
    olClasses() {
      return [
        `sm:flex justify-${this.leftAlign ? 'start' : 'center'} items-center flex-wrap`,
      ]
    },
    liClasses() {
      return [
        'mt-8 mx-1',
      ]
    },
  },
}
</script>

<style lang="scss">
.card-list {
  @screen md {
    margin: 0 -10px;
  }
}

  .card-list__item {
    width: 100%;
    margin: 30px 0 0;

    @screen md {
      width: calc(50% - 20px);
      margin: 20px 10px 0;
    }

    @screen lg {
      width: calc(25% - 20px);
      margin: 20px 10px 0;
    }
  }
</style>
